// Higher-order function is needed to mock constructor
module.exports = function() {
  return {
    addMarker: jest.fn(),
    removeMarkers: jest.fn()
  };
};
